import React from 'react';
import { Link } from 'react-router-dom';
import { ShareIcon } from '@heroicons/react/24/outline';
import { WITH_COUNSELOR } from '../../../content/landingHome';
import { Eyebrow, StartFree, Arrow } from './parts';

// Stratia alongside a counselor (#4972, founder 2026-10-20). The planning
// section's look (eyebrow, serif heading, a ruled list of four), then the
// sharing block and the partner line, then Start free. Every word is
// content/landingHome.js WITH_COUNSELOR's.
//
// `masters`: true only when the page shows the Master's section
// (mastersSectionVisible: india_masters on for this visitor and an India
// region). The master's line is future tense and never renders otherwise,
// so no visitor reads a master's feature as live.
export default function WithCounselor({ onStart, masters = false, copy = WITH_COUNSELOR }) {
    return (
        <section id="with-counselor" data-landing-section="with_counselor" data-testid="landing-with-counselor"
            className="scroll-mt-20 bg-[#FDFCF7] px-4 py-10 sm:px-6 lg:px-8 lg:py-16">
            <div className="mx-auto max-w-6xl">
                <div className="mx-auto mb-8 max-w-3xl text-center">
                    <Eyebrow>{copy.eyebrow}</Eyebrow>
                    <h2 className="[text-wrap:balance] mb-3 font-serif text-3xl font-bold leading-tight text-[#1A4D2E] sm:text-4xl">{copy.title}</h2>
                    <p className="mx-auto max-w-2xl text-lg leading-relaxed text-[#4A4A4A] [text-wrap:pretty]">{copy.sub}</p>
                </div>

                <ul role="list" className="m-0 grid list-none gap-x-6 p-0 sm:grid-cols-2 lg:grid-cols-4" data-testid="landing-with-counselor-items">
                    {copy.items.map((item) => (
                        <li key={item.key} data-testid={`landing-with-counselor-${item.key}`} className="min-w-0 border-t border-[#E0DED8] py-3">
                            <h3 className="font-serif text-xl font-bold text-[#1A4D2E]">{item.title}</h3>
                            <p className="mt-0.5 text-base leading-snug text-[#4A4A4A] [text-wrap:pretty]">{item.body}</p>
                        </li>
                    ))}
                </ul>

                <div className="mx-auto mt-8 flex max-w-3xl items-start gap-4 rounded-2xl border border-[#E0DED8] bg-white p-5 sm:gap-5 sm:p-6" data-testid="landing-with-counselor-share">
                    <div className="flex h-12 w-12 shrink-0 items-center justify-center rounded-full bg-[#F0F7F1]">
                        <ShareIcon className="h-6 w-6 text-[#1A4D2E]" aria-hidden="true" />
                    </div>
                    <div className="min-w-0">
                        <h3 className="[text-wrap:balance] font-serif text-2xl font-bold leading-tight text-[#1A4D2E]">{copy.shareTitle}</h3>
                        <p className="mt-2 text-base leading-relaxed text-[#2C2C2C]">{copy.share}</p>
                        <Link to={copy.shareGuide} data-cta="with_counselor_sharing_guide"
                            className="mt-3 inline-flex min-h-[44px] items-center gap-1.5 font-semibold text-[#1A4D2E] underline decoration-[#CFE3D4] underline-offset-4">
                            {copy.shareLink}<Arrow />
                        </Link>
                    </div>
                </div>

                <p className="mx-auto mt-8 max-w-2xl text-center text-lg font-semibold text-[#1A4D2E] [text-wrap:balance]" data-testid="landing-with-counselor-partner">
                    {copy.partner}
                </p>
                {masters && (
                    <p className="mx-auto mt-3 max-w-2xl text-center text-base text-[#4A4A4A] [text-wrap:balance]" data-testid="landing-with-counselor-masters">
                        {copy.masters}
                    </p>
                )}
                <div className="mt-6 flex flex-col items-center gap-3 sm:flex-row sm:justify-center sm:gap-6">
                    <StartFree onStart={onStart} cta="with_counselor_start_free" size="md" />
                    <Link to={copy.guide} data-cta="with_counselor_guide"
                        className="inline-flex min-h-[44px] items-center text-center font-semibold text-[#1A4D2E] underline decoration-[#CFE3D4] underline-offset-4">
                        {copy.guideLink}
                    </Link>
                </div>
            </div>
        </section>
    );
}
